import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  ImageListItem,
  Select, MenuItem, FormControl
} from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  COMPARE_VALUE,
  NUMBER_OF_APPLICANT,
  applicantCountConstant,
} from "../../../config/constant";
import SelectInput from "../../../components/SelectInput";
import BoxCheckInput from "../../../components/BoxCheckInput";
import puravankarLogo from "../../../assets/icons/puravankara-logo.svg";
import ProvidentLogo from "../../../assets/icons/Provident.svg";
import PurvaLandLogo from "../../../assets/icons/Purva Land 1.svg";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";


import {
  setApplicantTotal,
  setIsError,
  getOppprtunityDetails,
  setEOIBooking,
  setStepEOI,
  createBooking
} from "../../new-booking-form/new-booking-form.slice";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Turnstile from "react-turnstile";
import Loader from "../../../components/Loader";
import "./style.scss";
import SnackbarAlert from "../../../shared-components/snackbar-alert/SnackbarAlert";
const { REACT_APP_S3_BASE_URL } = process.env;

const ApplicantCount = () => {
  const formDataFormik = useFormik({
    initialValues: {
      numberOfApplicant: null,
      selectedApplicant: null,
      relationship: null,
    },
    
    onSubmit: (values) => {
      handleSaveForm(values);
    },
    validationSchema: yup.object().shape({
      numberOfApplicant: yup
        .number()
        .required("Number of Applicant is required"),
      selectedApplicant: yup
        .number()
        .when("numberOfApplicant", (numberOfApplicant, schema) => {
          return numberOfApplicant > 1
            ? schema.required("Please select one of the applicants")
            : schema.notRequired();
        }),
    }),
  });
  const dispatch = useDispatch();
  const { oppId } = useParams();
  const {
    enquiryDetails,
    isError,
    isLoading,
    masterData,
    error,
    projectBrandImage,
    EOIBooking,
    stepEOI,
  } = useSelector((state) => state?.newBookingForm);
  const [snackbarConfig, setSnackbarConfig] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [captchaToken, setCaptchaToken] = useState("");
  //States for EOI-BOOKING Applicant Position Changes
  const [options, setOptions] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [savedOptions,setSavedOptions] = useState('')
  const [cname, setCname] = useState('null');
  const handleVerify = (token) => {
    setCaptchaToken(token);
  };

  useEffect(() => {
    const newValues = {
      numberOfApplicant: formDataFormik?.values?.numberOfApplicant,
      selectedApplicant: null,
      relationship: null,
    };
    formDataFormik.setValues(newValues);
  // Code for EOI-BOOKING Applicant Position Changes
    if(Array.isArray(savedOptions)){
  let updatedSelectedOptions = [...savedOptions];
  const numberOfApplicants = formDataFormik?.values?.numberOfApplicant || 0;
  if (numberOfApplicants > updatedSelectedOptions.length) {
    updatedSelectedOptions = updatedSelectedOptions.concat(
      new Array(numberOfApplicants - updatedSelectedOptions.length).fill(undefined)
    );
  } else if (numberOfApplicants < updatedSelectedOptions.length) {
    updatedSelectedOptions = updatedSelectedOptions.slice(0, numberOfApplicants);
  }
  setSelectedOptions(updatedSelectedOptions);
    }
    else{
      
      setSelectedOptions(new Array(formDataFormik?.values?.numberOfApplicant).fill(undefined))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formDataFormik?.values?.numberOfApplicant]);

  useEffect(() => {
    if (isError && error?.includes("Duplicate entry")) {
      setSnackbarConfig({
        open: true,
        message: "Your Booking form is already submitted",
        severity: "success",
      });
      dispatch(setIsError(!isError));
    }
    //  else if(isError) {
    //   setSnackbarConfig({
    //     open: true,
    //     message: ERROR_MESSAGE,
    //     severity: "error",
    //   });
    // }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isError]);
  //Code for EOI-BOOKING Applicant Position Changes
  useEffect(() => {
      if (oppId?.length > 0) {
        dispatch(getOppprtunityDetails(`/${oppId}`))
          .unwrap()
          .then((res) => {
            setCname(`${res.data?.Cname} ${res.data?.X1st_Applicant_Last_Name}`)
            const applicants = [
              `${res.data?.Cname?res.data?.Cname:''} ${res.data?.X1st_Applicant_Last_Name?res.data?.X1st_Applicant_Last_Name:''}`,
              `${res.data?.C2name?res.data?.C2name:''} ${res.data?.c2LastName?res.data?.c2LastName:''}`,
              res.data?.Applicant_Name_3rd?res.data?.Applicant_Name_3rd:'',
              res.data?.Applicant_Name_4th?res.data?.Applicant_Name_4th:'',
            ];
            const applicantObjects = applicants
              .filter(name => name && name.trim().length > 0) // Filter out empty or undefined names
              .map(name => ({
                name: name.trim(),
                value: name.trim(),
              }));
              setOptions(applicantObjects)
              dispatch(setEOIBooking(res.data.EOI_Booking))
            dispatch(setStepEOI(0))
          // eslint-disable-next-line react-hooks/exhaustive-deps
          })}},[])

      const handleSaveForm = (data) => {
    dispatch(setApplicantTotal(data?.numberOfApplicant));
    const fillingAsValue =
      formDataFormik?.values?.numberOfApplicant === 1
        ? formDataFormik?.values?.numberOfApplicant
        : formDataFormik?.values?.selectedApplicant;
    let payload = {
      noOfApplicants: formDataFormik?.values?.numberOfApplicant,
      fillingAs:
        EOIBooking ? 1 : fillingAsValue,
      relationBtApplicants: formDataFormik?.values?.relationship,
      opportunityId: oppId,
      enquiryId: enquiryDetails?.data?.EnqId || null,
      lastStep: 0,
      isEOIBooking:EOIBooking,
      applicant1:selectedOptions[0],
      applicant2:selectedOptions[1],
      applicant3:selectedOptions[2],
      applicant4:selectedOptions[3],  
    bookingAs:'Individual'  };
    try {
      dispatch(createBooking(payload));
    } catch (error) {
      console.log(error);
    }
  };
  const isDisable = useMemo(() => {
    if(EOIBooking){
      if( formDataFormik?.values?.numberOfApplicant>1&& stepEOI===2 ){
        return !(formDataFormik?.values?.relationship && captchaToken?.length > 0);
      }
      if(formDataFormik?.values?.numberOfApplicant===1){
        return !selectedOptions.every(option => typeof option === "string" && captchaToken?.length > 0);
        }
      return false
    }
    if (formDataFormik.values.numberOfApplicant === 1 && captchaToken?.length > 0) {
      return false;
    } else if (
      formDataFormik?.values?.numberOfApplicant !== 1 &&
      formDataFormik?.values?.relationship !== null &&
      formDataFormik?.values?.selectedApplicant !== null &&
      captchaToken?.length > 0
    ) {
      return false;
    } else {
      return true;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formDataFormik.values, captchaToken,selectedOptions,stepEOI]);

  const handleSnackbarClose = () => {
    setSnackbarConfig({
      open: false,
      message: "",
      severity: "",
    });
  };

  const getBrandImage = () => {
    if (
      enquiryDetails?.data &&
      enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.Puravankara
    ) {
      return puravankarLogo;
    } else if (
      enquiryDetails?.data &&
      enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.Provident
    ) {
      return ProvidentLogo;
    } else if (
      enquiryDetails?.data &&
      enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.PurvaLand
    ) {
      return PurvaLandLogo;
    }
  };
  // For oppID with EOIBOOKING:True, Change Applicants Position
  const handleOptionChange = (index, selectedOption) => {
    const newSelectedOptions = [...selectedOptions];
    newSelectedOptions[index] = selectedOption;
    setSelectedOptions(newSelectedOptions);
  };
  // For oppID with EOIBOOKING:True, Change Applicants Position
  const getFilteredOptions = (currentIndex) => {
    return options.filter(
      (option) =>
        !selectedOptions.includes(option.value) ||
        selectedOptions[currentIndex] === option.value
    );
  };
  //Code for EOI-BOOKING Applicant Position Changes
  const optionList = () => {
      let list = [];
      for (let i = 1; i <= formDataFormik.values.numberOfApplicant; i++) {
        list.push({
          name: (
            <span>
              {i === 1 ? (
                applicantCountConstant.numberKeys[i]
              ) : (
                <>
                  {i}
                  <span className="textTop">
                    <sup>{applicantCountConstant.numberKeys[i]}</sup>
                  </span>
                </>
              )}{" "}
              Applicant
            </span>
          ),
          value: i,
        });
      }
      return list;
  };

  const showCaptcha =() =>{
    if(EOIBooking){
      if(formDataFormik.values.numberOfApplicant>1 && stepEOI===2){
        return true
      }
      if(formDataFormik.values.numberOfApplicant===1 && stepEOI===1){
        return true
      }
      return false
    }
    return true
  }
  //Code for EOI-BOOKING Applicant Position Changes
  const handleOnChange = (e, index, key, list) => {
      let selectedValue = list[index]?.value;
      formDataFormik.setFieldValue(key, selectedValue);
  };

  //Code for EOI-BOOKING Applicant Position Changes
  const backBtn=()=>{ 
      if(!selectedOptions.every(option => option === undefined)){
        setSavedOptions(selectedOptions)
      }
      return stepEOI===2?dispatch(setStepEOI(1)):dispatch(setStepEOI(0))
  }

  //Code for EOI-BOOKING Applicant Position Changes
  const showRelationshipQuesion = () => {
    if (EOIBooking) {
      return stepEOI === 2;
    }
    return (
      formDataFormik?.values?.selectedApplicant &&
      formDataFormik?.values?.numberOfApplicant !== 1
    );
  };  
    
  //Code for EOI-BOOKING Applicant Position Changes
  useEffect(()=>{
    let index = selectedOptions.indexOf(cname)
    formDataFormik.setValues({...formDataFormik?.values, selectedApplicant: index + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[selectedOptions])
  
  const nextBtn = ()=>{
      if(stepEOI===0){
        dispatch(setStepEOI(1))
      }
      if(stepEOI===1){
        dispatch(setStepEOI(2))
      }
  }

  //Code for EOI-BOOKING Applicant Position Changes
   const showNumberofApplicant = () => {
    if (EOIBooking) {
      return stepEOI === 0;
    }
    return true;
   };

  //Code for EOI-BOOKING Applicant Position Changes
   const showNextBtn =()=>{
    if(EOIBooking){
      if(formDataFormik?.values?.numberOfApplicant===1 && stepEOI>0){
        return true
      }
      if(stepEOI===2){
        return true
      }
      return false
    }
    return true
   }

  //Code for EOI-BOOKING Applicant Position Changes
   const showfirstNext = () =>
    EOIBooking &&
    stepEOI < 2 &&
    !(stepEOI === 1 && formDataFormik.values.numberOfApplicant === 1);

  //Code for EOI-BOOKING Applicant Position Changes
   const showChangeOrder = () => EOIBooking && stepEOI === 1;

  //Code for EOI-BOOKING Applicant Position Changes
   const nextDisable = ()=>{
  if(formDataFormik?.values?.numberOfApplicant)
    { 
      if(stepEOI===1){
        return !selectedOptions.every(option => typeof option === "string");
      }
      return false
  }   
    return true
  }
  const applicantName = selectedOptions[0]==='Add New'?'':` ${selectedOptions[0]}`
  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      <div
        style={{
          backgroundImage: `url("${
            REACT_APP_S3_BASE_URL + "/" + projectBrandImage
          }")`,
        }}
        className="applicantCountContainer applicantBackground"
      >
        <div className="overly">
          <div className="cardContainer">
            <div className="addScrollContainer">
            <Card className="cardContent">
              <form
                className="addScrollContainerForm"
                onSubmit={formDataFormik.handleSubmit}
                onReset={formDataFormik.handleReset}
              >
                <CardContent sx={{ p: 0 }}>
                  <ImageListItem
                    sx={{
                      mb: {
                        xs: 2,
                        sm: 3,
                        md: 5,
                      },
                    }}
                  >
                    {getBrandImage() ? (
                      <img src={getBrandImage()} alt="Puravankara Logo" />
                    ) : null}
                  </ImageListItem>
                  <Typography
                    className="BlackPearl"
                    sx={{
                      fontWeight: "600",
                      fontSize: "20px",
                      textAlign: "center",
                      lineHeight: "30px",
                      mb: 1,
                    }}
                  >
                    {"Your dream home awaits!"}
                  </Typography>
                  <Typography
                    className="BlackPearl"
                    sx={{ fontWeight: "400", textAlign: "center", mb: 2 }}
                  >
                    {
                      "Please fill in your details to book your dream home with us today."
                    }
                  </Typography>
                  { showNumberofApplicant()&& <div className="selectInput">
                    <SelectInput
                      field={{
                        name: "numberOfApplicant",
                        label: "Number of Applicants",
                        required: true,
                        readonly: false,
                        options: NUMBER_OF_APPLICANT,
                        placeholder: "Select",
                        showIcon: true,
                        // value: formDataFormik?.values?.numberOfApplicant
                      }}
                      formik={formDataFormik}
                    />
                  </div>}
                  {/*For EOIBooking:true Change Applicant Position */}
                  { showChangeOrder() &&<div style={{display:'flex', flexDirection:'column'}}>
                    {Array.from({ length: formDataFormik?.values?.numberOfApplicant }).map((_, index) => (
                      <FormControl
                        key={`applicant-${index + 1}`}
                        style={{
                          color: "#1c252e",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "22px",
                          mb: "6px",
                        }}>
                      <div>  
                        <label style={{fontSize:'14px'}}>Applicant {index+1}</label>  
                        <Select
                          IconComponent={ExpandMoreIcon}
                          style={{ marginBottom: "1rem", width:'100%',borderRadius: "8px", 
                            height:'44px',padding:'10px 14px',marginTop:'5px'}}
                          value={selectedOptions[index] || savedOptions[index] || "" }
                          onChange={(e) => handleOptionChange(index, e.target.value)}
                          sx={{
                            '.MuiSelect-select': {
                              color: 'rgba(26, 64, 125, 1)',
                            }}}
                          displayEmpty
                        >
                          <MenuItem style={{color:'#ff000'}} value="" disabled>
                            Select
                          </MenuItem>
                          {getFilteredOptions(index).map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.name}
                            </MenuItem>
                          ))}
                          <MenuItem value='Add New'>
                          Add New
                            </MenuItem>
                        </Select>
                      </div>
                      </FormControl>
                    ))}
                  </div>}
                  {formDataFormik?.values?.numberOfApplicant  && !EOIBooking &&
                  formDataFormik?.values?.numberOfApplicant !== 1 ? (
                    <div className="ApplicantTab">
                      {enquiryDetails?.data &&
                      enquiryDetails?.data?.Cname?.length > 0 ? (
                        <span className="textHello">
                          {`Hello ${enquiryDetails?.data?.Cname}, are you the`}
                        </span>
                      ) : null}
                      <BoxCheckInput
                        field={{
                          name: "selectedApplicant",
                          required: false,
                          readonly: false,
                          options: optionList(),
                          grid: true,
                          xsCol: 12,
                          smCol: 6,
                          mdCol: 6,
                          lgCol: 6,

                          handleOnChange,
                        }}
                        formik={formDataFormik}
                      />
                    </div>
                  ) : null}
                  {showRelationshipQuesion() ? (
                    <div className="ApplicantTabLast">
                      <SelectInput
                        field={{
                          showIcon: true,
                          name: "relationship",
                          label: (
                            <span
                              className="textHello"
                              style={{ display: "inline-block" }}
                            >
                              
                              {EOIBooking?`Hello${applicantName}, how are you related to the 2nd applicant?`:`How are you related to the `}
                              
                             { EOIBooking?'': (() => {
                                const targetApplicant = formDataFormik?.values?.selectedApplicant === 1 ? 2 : 1;
                                return targetApplicant === 1 ? (
                                  applicantCountConstant.numberKeys[1]
                                ) : (
                                  <>
                                    {targetApplicant}
                                    <span className="textTop">
                                      <sup>{applicantCountConstant.numberKeys[targetApplicant]}</sup>
                                    </span>
                                  </>
                                );
                              })()}
                              {EOIBooking?'':' Applicant* ? You are:'}
                            </span>
                          ),
                          required: false,
                          readonly: false,
                          options: masterData?.Relation_with_Applicant || [], //APPLICANT_RELATION
                          placeholder: "Select",
                        }}
                        formik={formDataFormik}
                      />
                    </div>
                  ) : null}
                  
                </CardContent>
                {showCaptcha() && <div className="captcha">
                  <Turnstile
                    sitekey="0x4AAAAAAA1D27m42F_ZsczD"
                    onVerify={handleVerify}
                    options={{ theme: "light" }}
                  />
                </div>}
                <div style={{display:'flex'}}>
                {stepEOI>0 && <Button
                  onClick={backBtn}
                  className={"saveLater"}
                  sx={{
                    background: "#ff00",
                    color: "#1a407d",
                    fontSize: "14px",
                    fontWeight: "700",
                    display: "block",
                    width: "45%",
                    height: "48px",
                    borderRadius: "8px",
                    textTransform: "capitalize",
                    margin: "0px auto 0px auto",
                    border:'1px solid  #0c2856',
                    p: 0,
                    "&:hover": {
                      backgroundColor: "#1A407D",
                      color:"white"
                    },
                  }}
                >
                  Back
                </Button>}
                {showNextBtn() &&<Button
                  type="submit"
                  disabled={isDisable}
                  className={isDisable ? "disableCTA" : ""}
                  sx={{
                    background: "#1A407D",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "700",
                    display: "block",
                    width: "45%",
                    height: "48px",
                    borderRadius: "8px",
                    textTransform: "capitalize",
                    margin: "0px auto 0px auto",
                    "&:hover": {
                      backgroundColor: "#0c2856",
                    },
                  }}
                >
                  Next
                </Button>}
                {showfirstNext()  && <Button
                  onClick={nextBtn}
                  disabled={nextDisable()}
                  className={nextDisable() ? "disableCTA" : ""}
                  sx={{
                    background: "#1A407D",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "700",
                    display: "block",
                    width: "45%",
                    height: "48px",
                    borderRadius: "8px",
                    textTransform: "capitalize",
                    margin: "0px auto 0px auto",
                    "&:hover": {
                      backgroundColor: "#0c2856",
                    },
                  }}
                >
                Next
                </Button>}
                </div>
              </form>
            </Card>
            </div>
          </div>
        </div>
      </div>
      <SnackbarAlert
        open={snackbarConfig.open}
        message={snackbarConfig.message}
        severity={snackbarConfig.severity}
        onClose={handleSnackbarClose}
      />
    </>
  );
};

export default ApplicantCount;
